/* REDUX STORE ENTITY NAMES */
export const APP = 'app';
